import React, { useEffect, useState } from "react";
import {
    IonPage,
    IonContent,
    IonCard,
    IonCardContent,
    IonButton,
    IonTextarea,
    IonAlert,
    IonLabel,
} from "@ionic/react";

interface QuestionData {
    originalParagraph: string;
    correctParagraph: string;
}

const PunctuationWorksheet: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [showError, setShowError] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };


    const handleCheckAnswer = () => {
        if (selectedOption !== null) {
            const normalizedInput = selectedOption
                .trim()
                .replace(/\s+/g, " ")
                .toLowerCase();
            const normalizedAnswer = questions[currentIndex]?.correctParagraph
                .trim()
                .replace(/\s+/g, " ")
                .toLowerCase();

            if (normalizedInput === normalizedAnswer) {
                // Automatically move to the next question
                setShowImage(true);
                setShowError(false);
                setTimeout(() => {
                    const nextIndex = currentIndex + 1;
                    setCurrentIndex(nextIndex);
                    setShowImage(false);
                    setSelectedOption(null);
                }, 5000); // Delay reduced to 3 seconds
            }
            else {
                setShowError(true);
            }
        }

    };

    const handleNextQuestion = () => {
        const nextIndex = currentIndex + 1;
        setCurrentIndex(nextIndex);
        setShowImage(false);
        setSelectedOption(null);
    }

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'RewriteParagraph.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/RewriteParagraph.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class One - English - Punctuation - Rewrite the Paragraph"; // Set page title
    }, []);

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter fillPreposition additionWord">
                        <IonLabel>
                            <p>
                                <strong>Original Paragraph:</strong>
                            </p>
                            <p>{questions[currentIndex]?.originalParagraph}</p>
                        </IonLabel>
                        <IonLabel>
                            <p>
                                <strong>Rewritten Paragraph:</strong>
                            </p>
                        </IonLabel>
                        <div className="mb-5">
                            <IonTextarea
                                placeholder="Rewrite the paragraph here..."
                                value={selectedOption}
                                onIonInput={(e) => setSelectedOption(e.detail.value!)}
                                rows={2}
                                auto-grow
                                className={`${showError == true ? "errorItems" : ""}`}
                            />
                        </div>

                        {showError == true ?
                            <>
                                <div className="mb-5">
                                    <h5>Correct answer is -</h5>
                                    <p>{questions[currentIndex]?.correctParagraph}</p>
                                </div>

                                <div className="optionButton" onClick={handleNextQuestion}>
                                    Next Question
                                </div>
                            </>
                            :
                            <>
                            <div className="optionButton" onClick={handleCheckAnswer}>
                                Submit Answer
                            </div>
                            </>
                        }
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default PunctuationWorksheet;
